const safeSessionStorage = {
  get: (key: string): string | null => {
    try {
      if (typeof sessionStorage !== "undefined") {
        return sessionStorage.getItem(key);
      }
    } catch (error) {
      const tempStorage = (window as any).tempSessionStorage || {};
      return tempStorage[key] || null;
    }
    return null;
  },

  set: (key: string, value: string): void => {
    try {
      if (typeof sessionStorage !== "undefined") {
        sessionStorage.setItem(key, value);
        return;
      }
    } catch (error) {
      const tempStorage = ((window as any).tempSessionStorage = (window as any).tempSessionStorage || {});
      tempStorage[key] = value;
    }
  },

  remove: (key: string): void => {
    try {
      if (typeof sessionStorage !== "undefined") {
        sessionStorage.removeItem(key);
        return;
      }
    } catch (error) {
      const tempStorage = (window as any).tempSessionStorage || {};
      if (tempStorage[key]) {
        delete tempStorage[key];
      }
    }
  },

  clear: (): void => {
    try {
      if (typeof sessionStorage !== "undefined") {
        sessionStorage.clear();
        return;
      }
    } catch (error) {
      (window as any).tempSessionStorage = {};
    }
  },
};

export default safeSessionStorage;



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/store/safe-session-storage.ts